import React from "react";
// import { useContext } from "react";

// Assets
import influencerTwitter from "../../../../../assets/influencerTwitter.png";
import influencerPlaceholder from "../../../../../assets/influencerPlaceholder.png";
// import AddedInfluencer from "../addedInfluencer/AddedInfluencer";
// import { Post } from "../Influencer";

function InfluencerCard(props) {
  // const { post, setPost } = useContext(Post);
  return (
    <div
      className="card influencer-card"
      // onClick={() => {
      //   console.log(props.data);
      //   setPost(props.data);
      // }}
    >
      <div>
        <img
          src={props.data.imageUrl}
          onError={(e) => {
            e.target.src = influencerPlaceholder;
          }}
          alt="Influencer"
          className="influencer-image"
        />
        <div className="influencer-details">
          <img src={influencerTwitter} alt="Influencer Twitter" />
          <p className="yellow">{props.data.name} </p>
          <p className="followers">{props.data.followers}</p>
        </div>
      </div>
    </div>
  );
}

export default InfluencerCard;
